export default "__VITE_ASSET__Cgjpyjfs__"